// Welle 4 — Admin V2 Platform Dashboard API client.
import { apiClient as api } from "./client";

export async function fetchDashboardOverview() {
  const { data } = await api.get("/admin/dashboard/overview");
  return data;
}

export async function fetchVisionQueue(limit = 20) {
  const { data } = await api.get("/admin/dashboard/vision-queue", {
    params: { limit },
  });
  return data;
}

export async function fetchPendingQueue({ kind, status = "pending", limit = 50 } = {}) {
  const { data } = await api.get("/admin/dashboard/pending-queue", {
    params: { kind: kind || undefined, status, limit },
  });
  return data;
}

export async function reviewPendingItem(kind, id, action) {
  const { data } = await api.patch(`/admin/dashboard/pending-queue/${kind}/${id}`, {
    action,
  });
  return data;
}

export async function fetchGeoSuspects(vertical = "immo", limit = 50) {
  const { data } = await api.get("/admin/suspect-listings/geo", {
    params: { vertical, limit },
  });
  return data;
}

export async function fetchDamageSuspects(vertical = "auto", limit = 50) {
  const { data } = await api.get("/admin/suspect-listings", {
    params: { vertical, limit },
  });
  return data;
}
